function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[hidden],[inert]') && (!el.closest('details:not([open])') || el.tagName === 'SUMMARY'));
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
// Performance: run this after first paint to reduce main-thread work during LCP/TTI (especially mobile).
(function initFocusVisibleAfterPaint(){
  const run = () => {
    try { document.querySelector(":focus-visible"); } catch { focusVisiblePolyfill(); }
  };
  if ('requestIdleCallback' in window) {
    requestIdleCallback(run, { timeout: 1500 });
  } else {
    setTimeout(run, 1);
  }
})();


function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  }, { passive: true });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.boundDrawerElements = this.boundDrawerElements || new WeakSet();
    this.querySelectorAll('summary').forEach(summary => {
      if (this.boundDrawerElements.has(summary)) return;
      this.boundDrawerElements.add(summary);
      this.addAccessibilityAttributes([summary]);
      summary.addEventListener('click', this.onSummaryClick.bind(this));
      summary.parentElement.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(summary.parentElement.open));
      });
    });
    this.querySelectorAll('.menu-drawer__close-button, .mobile-facets__close-button').forEach(button => {
      if (this.boundDrawerElements.has(button)) return;
      this.boundDrawerElements.add(button);
      button.addEventListener('click', this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', String(element.parentElement.open));
      const panel = element.nextElementSibling;
      if (panel) {
        if (!panel.id) panel.id = 'DrawerPanel-' + (++MenuDrawer.panelId);
        element.setAttribute('aria-controls', panel.id);
      }
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        if (!detailsElement.open) return;
        detailsElement.classList.add('menu-opening');
        // The submenu transitions from visibility:hidden. Focus it once that
        // transition completes, without pulling focus back if the user moved on.
        const panel = summaryElement.nextElementSibling;
        let focused = false;
        const focusPanel = () => {
          if (focused || !detailsElement.open || !detailsElement.classList.contains('menu-opening')) return;
          focused = true;
          panel.removeEventListener('transitionend', focusPanel);
          if (document.activeElement === summaryElement || panel.contains(document.activeElement)) {
            trapFocus(panel, panel.contains(document.activeElement) ? document.activeElement : detailsElement.querySelector('button'));
          }
        };
        panel.addEventListener('transitionend', focusPanel);
        setTimeout(focusPanel, 450);
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      if (!this.mainDetailsToggle.open) return;
      this.mainDetailsToggle.classList.add('menu-opening');
      trapFocus(this.mainDetailsToggle, summaryElement);
    });
    summaryElement.setAttribute('aria-expanded', true);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = this.mainDetailsToggle.querySelector('summary')) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer(event, false);
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

MenuDrawer.panelId = 0;
customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      if (!this.mainDetailsToggle.open) return;
      this.mainDetailsToggle.classList.add('menu-opening');
      trapFocus(this.mainDetailsToggle, summaryElement);
    });

    summaryElement.setAttribute('aria-expanded', true);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this), { passive: true });
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
  super();
  this.initLoad();
  this.addEventListener('change', this.onVariantChange);
  this.addEventListener('click', (event) => {
    if (event.target.closest('[data-variant-retry]')) this.onVariantChange();
  });
 }
  initLoad(){
  this.updateOptions();
  this.updateMasterId();
  try { this.updateMedia(); } catch(e) {}
 }

  onVariantChange() {
    this.variantRequestId = (this.variantRequestId || 0) + 1;
    this.variantAbort?.abort();
    this.removeAttribute('aria-busy');
    const retry = this.querySelector('[data-variant-retry]');
    if (retry) {
      if (document.activeElement === retry) this.querySelector('select')?.focus();
      retry.hidden = true;
    }
    this.updateOptions();
    this.updateMasterId();
    this.updateDeliveryAvailability();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      const input = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('input[name="id"]');
      if (input) input.disabled = true;
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.announceVariant(window.variantStrings.unavailable);
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      try { this.updateMedia(); } catch(e) {}
      try {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: this.currentVariant, sectionId: this.dataset.section } }));
        document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: this.currentVariant, sectionId: this.dataset.section } }));
      } catch(e) {}
    }
  }

  updateDeliveryAvailability() {
    document.querySelectorAll('[data-delivery-section][data-in-stock-variants]').forEach((root) => {
      if (root.dataset.deliverySection !== this.dataset.section) return;
      const eligible = !!this.currentVariant && this.currentVariant.available && root.dataset.inStockVariants.split(',').includes(String(this.currentVariant.id));
      root.hidden = !eligible;
      root.inert = !eligible;
      if (!eligible) {
        const info = document.getElementById(root.id + '-tip-modal');
        if (info?.open) { info.close(); info.hidden = true; }
      }
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }


  getMediaRoot() {
    if (this._mediaRoot && document.body.contains(this._mediaRoot)) return this._mediaRoot;

    var root = null;
    if (this.dataset && this.dataset.section) {
      root = document.getElementById(`MainProduct-${this.dataset.section}`);
      if (!root) {
        var infoRoot = document.getElementById(`ProductInfo-${this.dataset.section}`);
        root = infoRoot ? (infoRoot.closest('.shopify-section') || infoRoot.closest('section')) : null;
      }
    }

    if (!root) {
      root = this.closest('.shopify-section') || this.closest('section') || document;
    }

    this._mediaRoot = root;
    return this._mediaRoot;
  }

 updateMedia() {
if (!this.currentVariant || !this.currentVariant.featured_media) return;
var current_media_id = Number(this.currentVariant.featured_media.id);

try {
  var root = this.getMediaRoot();
  var slider = (root && root.querySelector) ? root.querySelector('.product__image-slider') : null;
  if (!slider) slider = document.querySelector('.product__image-slider');

  // Product page with Flickity
  if (slider) {
    var sliderTrack = slider.querySelector('.flickity-slider');
    if (!sliderTrack || !window.flkty || typeof window.flkty.select !== 'function') return;

    var sliderImages = slider.querySelectorAll('img[data-media-id]');
    if (!sliderImages.length) return;

    if (this._sliderEl !== slider || !this._sliderMediaIds || this._sliderMediaCount !== sliderImages.length) {
      this._sliderEl = slider;
      this._sliderMediaCount = sliderImages.length;
      this._sliderMediaIds = Array.from(sliderImages)
        .map(function(img){ return parseInt(img.getAttribute('data-media-id'), 10); })
        .filter(function(id){ return !Number.isNaN(id); });
    }

    var targetIndex = this._sliderMediaIds.indexOf(current_media_id);
    if (targetIndex > -1 && window.flkty.selectedIndex !== targetIndex) window.flkty.select(targetIndex);
    return;
  }

  // Featured products on homepage without Flickity
  var mediaList = (root && root.querySelector) ? root.querySelector('.product__media-list') : null;
  if (!mediaList) mediaList = document.querySelector('.product__media-list');
  if (mediaList) {
    Array.from(mediaList.children).forEach(function(child) {
      var mediaAttr = child.getAttribute('data-media-id') || '';
      child.style.display = mediaAttr.indexOf(String(current_media_id)) > -1 ? 'block' : 'none';
    });
  }
} catch(e) {}
}

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.disabled = !this.currentVariant.available;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  announceVariant(message) {
    const status = this.querySelector('[data-variant-status]');
    if (status) { status.textContent = message || ''; status.classList.add('visually-hidden'); }
  }

  renderProductInfo() {
    const variant = this.currentVariant;
    const requestId = this.variantRequestId;
    const controller = new AbortController();
    this.variantAbort = controller;
    const timer = setTimeout(() => controller.abort(), 12000);
    this.setAttribute('aria-busy', 'true');
    fetch(`${this.dataset.url}?variant=${variant.id}&section_id=${this.dataset.section}`, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error('Variant response failed');
        return response.text();
      })
      .then((responseText) => {
        if (requestId !== this.variantRequestId || this.currentVariant?.id !== variant.id) return;
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (destination && !source) throw new Error('Variant price missing');
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!variant.available, window.variantStrings.soldOut);
        const selected = (this.dataset.selectedMessage || '__TITLE__').replace('__TITLE__', variant.title);
        this.announceVariant(variant.available ? selected : `${selected}. ${window.variantStrings.soldOut}`);
      })
      .catch(() => {
        if (requestId !== this.variantRequestId) return;
        this.toggleAddButton(true, '', false);
        const input = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('input[name="id"]');
        if (input) input.disabled = true;
        this.announceVariant(this.dataset.errorMessage || window.cartStrings?.error);
        this.querySelector('[data-variant-status]')?.classList.remove('visually-hidden');
        const retry = this.querySelector('[data-variant-retry]');
        if (retry) retry.hidden = false;
      })
      .finally(() => {
        clearTimeout(timer);
        if (requestId === this.variantRequestId) this.removeAttribute('aria-busy');
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    if (this.variantData) return this.variantData;

    const jsonScript = this.querySelector('[type="application/json"]');
    if (!jsonScript || !jsonScript.textContent) {
      this.variantData = [];
      return this.variantData;
    }

    try {
      this.variantData = JSON.parse(jsonScript.textContent);
    } catch (error) {
      console.warn('Variant JSON parse error:', error);
      this.variantData = [];
    }

    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

/* =========================================================
   TTH: Judge.me accessibility fixes (lighter boot)
   - Wait until Judge.me is near viewport / idle before wiring observers.
   - Keeps alt/title fixes without paying the cost during initial load.
   ========================================================= */
(() => {
  const WIDGET_SELECTOR = '#judgeme_product_reviews, .jdgm-review-widget, .jdgm-carousel-wrapper, .jdgm-all-reviews-page, .jdgm-widget';
  let started = false;

  const fix = (root) => {
    if (!root || !root.querySelectorAll) return;

    const arrowButtons = root.querySelectorAll('button.jdgm-arrow, button.jdgm-carousel__prev, button.jdgm-carousel__next');
    arrowButtons.forEach((btn) => {
      if (btn.hasAttribute('aria-label') && btn.getAttribute('aria-label')?.trim()) return;

      const onclick = (btn.getAttribute('onclick') || '').toLowerCase();
      let label = 'Carousel control';
      if (onclick.includes('prev')) label = 'Previous reviews';
      else if (onclick.includes('next')) label = 'Next reviews';
      else {
        const parent = btn.parentElement;
        if (parent) {
          const siblings = Array.from(parent.querySelectorAll('button.jdgm-arrow'));
          if (siblings.length >= 2) {
            const idx = siblings.indexOf(btn);
            if (idx === 0) label = 'Previous reviews';
            if (idx === 1) label = 'Next reviews';
          }
        }
      }
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
    });

    const imgs = root.querySelectorAll('.jdgm-widget img:not([alt]), .jdgm-review-widget img:not([alt]), .jdgm-carousel-wrapper img:not([alt])');
    imgs.forEach((img) => img.setAttribute('alt', 'Customer review media'));
  };

  let waitObserver = null;
  let waitTimer = null;

  const disconnectWaitObserver = () => {
    if (waitObserver) {
      waitObserver.disconnect();
      waitObserver = null;
    }
    if (waitTimer) {
      clearTimeout(waitTimer);
      waitTimer = null;
    }
  };

  const start = (targetRoot) => {
    if (started) return;
    started = true;

    fix(document);

    const scope = targetRoot || document.querySelector('#judgeme_product_reviews, .jdgm-carousel-wrapper, .jdgm-all-reviews-page, .jdgm-review-widget') || document.documentElement;
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (
            node.matches('.jdgm-widget, .jdgm-review-widget, .jdgm-all-reviews-page, .jdgm-carousel-wrapper') ||
            node.querySelector?.('.jdgm-widget, .jdgm-review-widget, .jdgm-all-reviews-page, .jdgm-carousel-wrapper')
          ) {
            fix(node);
          }
        }
      }
    });

    obs.observe(scope, { childList: true, subtree: true });
  };

  const deferStartForTarget = (target) => {
    if (!target) return;

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            io.disconnect();
            start(target);
          }
        });
      }, { rootMargin: '250px 0px' });
      io.observe(target);
    } else if ('requestIdleCallback' in window) {
      requestIdleCallback(() => start(target), { timeout: 4000 });
    } else {
      setTimeout(() => start(target), 1500);
    }
  };

  const waitForTarget = () => {
    if (started || waitObserver || !('MutationObserver' in window)) return;
    const scope = document.body || document.documentElement;
    if (!scope) return;

    waitObserver = new MutationObserver(() => {
      const lateTarget = document.querySelector(WIDGET_SELECTOR);
      if (!lateTarget) return;
      disconnectWaitObserver();
      deferStartForTarget(lateTarget);
    });

    waitObserver.observe(scope, { childList: true, subtree: true });
    waitTimer = setTimeout(disconnectWaitObserver, 8000);
  };

  const scheduleStart = () => {
    const target = document.querySelector(WIDGET_SELECTOR);
    if (target) {
      deferStartForTarget(target);
      return;
    }

    waitForTarget();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleStart, { once: true });
  } else {
    scheduleStart();
  }
})();


// Product gallery controls are generated by Flickity after its deferred load.
// Enhance those controls without changing the gallery's loading strategy.
(() => {
  function enhanceProductGallery(root) {
    if (root.dataset.tthKeyboardGallery) return;
    root.dataset.tthKeyboardGallery = 'true';
    root.setAttribute('role', 'region');
    const label = root.getAttribute('aria-label') || 'Product media';
    root.setAttribute('aria-label', label);
    function sync() {
      root.querySelectorAll('.flickity-page-dots .dot').forEach((dot, index) => {
        dot.setAttribute('role', 'button');
        dot.tabIndex = 0;
        dot.setAttribute('aria-label', 'Show product media ' + (index + 1));
        dot.setAttribute('aria-pressed', String(dot.classList.contains('is-selected')));
      });
    }
    root.addEventListener('keydown', event => {
      const dot = event.target.closest('.flickity-page-dots .dot');
      if (!dot || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      event.stopPropagation();
      const gallery = window.Flickity && window.Flickity.data(root);
      if (gallery) {
        const dots = Array.from(root.querySelectorAll('.flickity-page-dots .dot'));
        gallery.select(dots.indexOf(dot), false, matchMedia('(prefers-reduced-motion: reduce)').matches);
      } else dot.click();
    });
    const observer = new MutationObserver(sync);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    sync();
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) observer.disconnect();
    }, { once: true });
  }
  function init() {
    document.querySelectorAll('.product__image-slider').forEach(enhanceProductGallery);
    if (!document.querySelector('.product__image-slider') || document.getElementById('tth-gallery-keyboard-style')) return;
    const style = document.createElement('style');
    style.id = 'tth-gallery-keyboard-style';
    style.textContent = '.product__image-slider:focus-visible,.product__image-slider :focus-visible,.product__image-thumbnail:focus-visible,.product__image-thumbnail :focus-visible{outline:3px solid #005fcc!important;outline-offset:-4px!important}';
    document.head.appendChild(style);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
